import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { environment } from '../../../../../environments/environment'

@Component({
  standalone: false,
  selector: 'vs-featured-product-section',
  templateUrl: './featured-product-section.component.html',
  styleUrls: ['./featured-product-section.component.scss'],
})
export class FeaturedProductSectionComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  redirectToFeaturedProduct() {
    window.open(environment.masoSvi3, '_blank')
  }
}
